import { Message } from "../classes/Message"
export default class MessageBuilder {
  constructor(){
  }

  static encode(MessagePargraph){
    let EncodedMessage = ""
    let oMessage = new Message()
    let mention_arr = []
    let URL_arr = []
    let has_content = false
    let arrFiles = []
    // MessagePargraph.innerHTML = MessagePargraph.innerHTML.replace(/<!---->/g, "") // removing comments
    if(typeof MessagePargraph.data != 'undefined'){ // CASE empty field with just text for ****edit posts
      let EncodedText = MessagePargraph.data
      has_content = true
      EncodedMessage +=  EncodedText
    }
      // rows
      for(let i=0; i<MessagePargraph.childNodes.length;i++){

        if(MessagePargraph.childNodes[i].nodeName === "#commnent"){
          i++;
        }

        /**
         * text
         */
        if(typeof MessagePargraph .childNodes[i].data != 'undefined'){
          let EncodedText =MessagePargraph.childNodes[i].data
          has_content = true
          EncodedMessage +=  EncodedText
        }
        /**
         * emoji
         */
        if(MessagePargraph.childNodes[i].nodeName === "IMG" ||
            (MessagePargraph.childNodes[i].nodeName === "SPAN" && MessagePargraph.childNodes[i].dataset.type == "emoji")){
          has_content = true
          oMessage.addType("emoji")
          EncodedMessage +=  ' :'+MessagePargraph.childNodes[i].alt+': '
        }

        /**
         * mention
         */
        if(MessagePargraph.childNodes[i].nodeName === "SPAN" && MessagePargraph.childNodes[i].dataset.type != "emoji"){
            has_content = true
          if(MessagePargraph.childNodes[i].dataset.type == "folder" || MessagePargraph.childNodes[i].dataset.type == "file"){
            let file = {
              name:MessagePargraph.childNodes[i].innerText.slice(1),//.replace(/ /g, ''), // \t
              id: MessagePargraph.childNodes[i].dataset.mention,
              type:MessagePargraph.childNodes[i].dataset.type
            }
            arrFiles.push(file)
          }
          EncodedMessage +=  " " +MessagePargraph.childNodes[i].innerText //.replace(/ /g, '')+ " " // \t

        }
        if(MessagePargraph.childNodes[i].nodeName === "BR"){
          EncodedMessage += "\n"
        }
      }


    if(!has_content){
      return null
    }
    oMessage.setOrigin(EncodedMessage)
    oMessage.addFiles(arrFiles)
    return oMessage
  }



  static decode(oMessage){
    let text = oMessage.origin_parsed.trim()
    let textArr = text.split(/(\[[A-F0-9]{32}\])/g)
    let DecodedMessage = []
    for(let i=0; i< textArr.length;i++){
      if(textArr[i].length == 34 &&
        textArr[i][0] == "[" &&
        textArr[i][33] == "]"){
          if(textArr[i].slice(1,33) in oMessage.parsed_items){
            DecodedMessage.push(oMessage.parsed_items[textArr[i].slice(1,33)])
          }
     }else {
      DecodedMessage.push({"text": textArr[i], "type" : "text"})
      // let lines = textArr[i].split(/\n/g)
      // // DecodedMessage.push({"text": textArr[i].replace(' ', '\0'), "type" : "text"})
      // for(let l=0; l<lines.length;l++){
      //   let line_text = lines[l].trim()
      //   let word = line_text.split(' ')
      //   for(let w=0; w< word.length;w++){
      //     DecodedMessage.push({"text": word[w], "type" : "text"})
      //     DecodedMessage.push({"text": ' ', "type" : "text"})
      //   }
      //   if(line_text.length > 0 && lines.length > 1){
      //     DecodedMessage.push({ "text": "\n" ,"type" : "text"})
      //   }
      // }
     }
    }
    return DecodedMessage
  }

}
